
const contact = () => {

    const emailBtn = document.querySelectorAll('[data-email-btn]');
    const phoneBtn = document.querySelectorAll("[data-phone-btn]");
    const phoneNumberCopy = document.querySelectorAll("[data-phone-copy]");

    // Check if user is on a mobile device
    const isMobileDevice = () => {
        return /Mobi|Android|iP(ad|hone|od)|IEMobile|Opera Mini|BlackBerry|webOS|Windows Phone|Kindle|Silk-Accelerated|Mobile|BB10|Tablet|PlayBook/.test(navigator.userAgent);
    };
    const addEmailBtnListener = () => {
        if (emailBtn && emailBtn.length > 0) {
            emailBtn.forEach((btn) => {
                if (btn instanceof HTMLElement) {
                    btn.addEventListener('click', (event) => {
                        event.preventDefault();

                        // Filter to get only direct text nodes (exclude screen reader stuff)
                        const emailAddress = Array.from(btn.childNodes)
                            .filter((node) => node.nodeType === Node.TEXT_NODE)
                            .map((node) => node.textContent?.trim() || '')
                            .join('')
                            .trim();

                        if (emailAddress) {
                            const mailtoLink = `mailto:${emailAddress}`;
                            window.location.href = mailtoLink;
                        }
                    });
                }
            });
        } else return
    };

    const addPhoneBtnListener = () => {
        if (phoneBtn && phoneBtn.length > 0) {
            phoneBtn.forEach((btn) => {
                btn.addEventListener('click', (event) => {
                    event.preventDefault();
                    const phoneNumber = btn.textContent.trim();

                    if (isMobileDevice()) {
                        const telLink = `tel:${phoneNumber}`;
                        window.location.href = telLink;
                    } else {
                        navigator.clipboard.writeText(phoneNumber).then(() => {
                            phoneNumberCopy.forEach((copyElem) => {
                                copyElem.setAttribute("aria-hidden", "false");
                                copyElem.classList.remove('hidden');
                                setTimeout(() => {
                                    copyElem.setAttribute("aria-hidden", "true");
                                    copyElem.classList.add('hidden');
                                }, 5000);
                            });
                        }).catch(err => {
                            alert("Failed to copy phone number.");
                        });
                    }
                });
            });
        } else return
    };


    const init = () => {
        addEmailBtnListener();
        addPhoneBtnListener();
    };

    init();
};

document.addEventListener('DOMContentLoaded', () => {
    contact();
    window.addEventListener('resize', site.helpers.debounce(contact, 200));
});
